"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _airbnbPropTypes = require("airbnb-prop-types");

var _lodash = _interopRequireDefault(require("lodash.isempty"));

var _link = _interopRequireDefault(require("../Link/link"));

var _icon = _interopRequireDefault(require("../Icon/icon"));

var _DropdownStateful = _interopRequireDefault(require("../Dropdown/DropdownStateful"));

var _calendarHelper = require("./calendar-helper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var JAN = 1;
var DEC = 12;

function MonthList(_ref) {
  var selected = _ref.selected,
      onMonthClick = _ref.onMonthClick,
      months = _ref.months;
  return _react.default.createElement("div", {
    className: "co-datepicker__months"
  }, _react.default.createElement("ul", null, Object.values(months).map(function (month, index) {
    return _react.default.createElement("li", {
      key: month,
      className: selected === index + 1 ? 'co--active' : null
    }, _react.default.createElement(_link.default, {
      onClick: onMonthClick(index + 1)
    }, month));
  })));
}

function DatepickerHeader(_ref2) {
  var id = _ref2.id,
      month = _ref2.month,
      months = _ref2.months,
      onPreviousClick = _ref2.onPreviousClick,
      onMonthClick = _ref2.onMonthClick,
      onNextClick = _ref2.onNextClick,
      onYearChange = _ref2.onYearChange,
      year = _ref2.year,
      years = _ref2.years,
      canDecrement = _ref2.canDecrement,
      canIncrement = _ref2.canIncrement;
  var renderYearsDropdown = Array.isArray(years) && years.length;
  var selectedYear = renderYearsDropdown ? year || years[0] : null;
  return _react.default.createElement("div", {
    className: "co-datepicker__header"
  }, _react.default.createElement("div", {
    className: "co-datepicker__current-month"
  }, _react.default.createElement(_link.default, {
    ariaLabel: "Previous Month",
    onClick: onPreviousClick,
    disabled: !canDecrement
  }, _react.default.createElement(_icon.default, {
    name: _icon.default.CHEVRON_LEFT,
    small: true
  })), _react.default.createElement("span", null, _react.default.createElement(_link.default, {
    onClick: onMonthClick
  }, months[month])), _react.default.createElement(_link.default, {
    ariaLabel: "Next Month",
    onClick: onNextClick,
    disabled: !canIncrement
  }, _react.default.createElement(_icon.default, {
    name: _icon.default.CHEVRON_RIGHT,
    small: true
  }))), renderYearsDropdown ? _react.default.createElement("div", {
    className: "co-datepicker__current-year"
  }, _react.default.createElement(_DropdownStateful.default, {
    id: "".concat(id, "-years"),
    small: true,
    onChange: onYearChange
  }, years.map(function (yearString) {
    return _react.default.createElement(_DropdownStateful.default.Option, {
      key: yearString,
      value: yearString,
      selected: yearString === selectedYear
    }, yearString);
  }))) : null);
}

function getMonthNavigationStatus(month, year, years) {
  var canDecrement = true;
  var canIncrement = true;

  if (month === JAN) {
    canDecrement = (0, _lodash.default)(years) ? true : years[0] !== year;
  } else if (month === DEC) {
    canIncrement = (0, _lodash.default)(years) ? true : years[years.length - 1] !== year;
  }

  return {
    canDecrement: canDecrement,
    canIncrement: canIncrement
  };
}

var DatepickerNavigation =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(DatepickerNavigation, _React$PureComponent);

  function DatepickerNavigation(props) {
    var _this;

    _classCallCheck(this, DatepickerNavigation);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DatepickerNavigation).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "toggleMonthList", function () {
      _this.setState(_objectSpread({}, _this.state, {
        pickingMonth: !_this.state.pickingMonth
      }), _this.onChange);
    });

    _defineProperty(_assertThisInitialized(_this), "onMonthChange", function (newMonth) {
      return function () {
        var selectedYear = _this.state.selectedYear;
        var years = _this.props.years;

        _this.setState(_objectSpread({}, _this.state, {
          pickingMonth: !_this.state.pickingMonth,
          selectedMonth: newMonth
        }, getMonthNavigationStatus(newMonth, selectedYear, years)), _this.onChange);
      };
    });

    _defineProperty(_assertThisInitialized(_this), "decrementMonth", function () {
      var years = _this.props.years;
      var currentMonth = _this.state.selectedMonth;
      var selectedYear = _this.state.selectedYear;
      var selectedMonth;

      if (currentMonth === JAN) {
        selectedMonth = DEC;

        if (!(0, _lodash.default)(years)) {
          selectedYear = years[years.indexOf(selectedYear) - 1];
        }
      } else {
        selectedMonth = currentMonth - 1;
      }

      _this.setState(_objectSpread({}, _this.state, {
        selectedMonth: selectedMonth,
        selectedYear: selectedYear
      }, getMonthNavigationStatus(selectedMonth, selectedYear, years)), _this.onChange);
    });

    _defineProperty(_assertThisInitialized(_this), "incrementMonth", function () {
      var years = _this.props.years;
      var currentMonth = _this.state.selectedMonth;
      var selectedYear = _this.state.selectedYear;
      var selectedMonth;

      if (currentMonth === DEC) {
        selectedMonth = JAN;

        if (!(0, _lodash.default)(years)) {
          selectedYear = years[years.indexOf(selectedYear) + 1];
        }
      } else {
        selectedMonth = currentMonth + 1;
      }

      _this.setState(_objectSpread({}, _this.state, {
        selectedMonth: selectedMonth,
        selectedYear: selectedYear
      }, getMonthNavigationStatus(selectedMonth, selectedYear, years)), _this.onChange);
    });

    _defineProperty(_assertThisInitialized(_this), "updateYear", function (_ref3) {
      var value = _ref3.target.value;
      var selectedMonth = _this.state.selectedMonth;
      var years = _this.props.years;

      _this.setState(_objectSpread({}, _this.state, {
        selectedYear: value
      }, getMonthNavigationStatus(selectedMonth, value, years)), _this.onChange);
    });

    _defineProperty(_assertThisInitialized(_this), "onChange", function () {
      var _this$state = _this.state,
          pickingMonth = _this$state.pickingMonth,
          selectedMonth = _this$state.selectedMonth,
          selectedYear = _this$state.selectedYear;

      _this.props.onChange({
        month: selectedMonth,
        year: selectedYear,
        pickingMonth: pickingMonth
      });
    });

    var _selectedMonth = props.month || JAN;

    var _selectedYear = props.year || (props.years ? props.years[0] : null);

    _this.state = _objectSpread({
      pickingMonth: false,
      selectedMonth: _selectedMonth,
      selectedYear: _selectedYear
    }, getMonthNavigationStatus(_selectedMonth, _selectedYear, props.years));
    return _this;
  }

  _createClass(DatepickerNavigation, [{
    key: "render",
    value: function render() {
      var _this$state2 = this.state,
          selectedMonth = _this$state2.selectedMonth,
          selectedYear = _this$state2.selectedYear,
          canDecrement = _this$state2.canDecrement,
          canIncrement = _this$state2.canIncrement;
      var months = this.props.months || _calendarHelper.MONTHS;
      return this.state.pickingMonth ? _react.default.createElement(MonthList, {
        months: months,
        selected: selectedMonth,
        onMonthClick: this.onMonthChange
      }) : _react.default.createElement(DatepickerHeader, {
        id: this.props.id,
        month: selectedMonth,
        months: months,
        year: selectedYear,
        years: this.props.years,
        onPreviousClick: this.decrementMonth,
        onNextClick: this.incrementMonth,
        onMonthClick: this.toggleMonthList,
        onYearChange: this.updateYear,
        canDecrement: canDecrement,
        canIncrement: canIncrement
      });
    }
  }]);

  return DatepickerNavigation;
}(_react.default.PureComponent);

DatepickerNavigation.propTypes = {
  id: _propTypes.string,
  month: (0, _airbnbPropTypes.between)({
    gt: 0,
    lte: 12
  }),
  year: _propTypes.string,
  years: _propTypes.array,
  onChange: _propTypes.func
};
DatepickerNavigation.defaultProps = {
  onChange: function onChange() {}
};
var _default = DatepickerNavigation;
exports.default = _default;
DatepickerNavigation.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "toggleMonthList",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "onMonthChange",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "newMonth",
      "type": null
    }],
    "returns": null
  }, {
    "name": "decrementMonth",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "incrementMonth",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "updateYear",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "{ target: { value } }",
      "type": null
    }],
    "returns": null
  }, {
    "name": "onChange",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }],
  "displayName": "DatepickerNavigation",
  "props": {
    "onChange": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "id": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "month": {
      "type": {
        "name": "custom",
        "raw": "between({ gt: 0, lte: 12 })"
      },
      "required": false,
      "description": ""
    },
    "year": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "years": {
      "type": {
        "name": "array"
      },
      "required": false,
      "description": ""
    }
  }
};